import type { OpenApiGetJivoWidgetsResponseSuccess } from '#shared/api/schema';
import { JIVO_OAUTH_STORAGE_KEY, JIVO_SERVICE_NAME } from '#shared/lib/const';
import { getJivoOauthUrl } from '#shared/lib/url';
import { integrationJivoCredentialsGet, integrationJivoWidgetsGet } from '../api';
import { useOauthPopupConnect } from './useOauthPopupConnect';

type JivoWidget = NonNullable<OpenApiGetJivoWidgetsResponseSuccess['widgets']>[number];

type UseJivoOauthConnectIntegrationParams = {
    onAuthorized: (widgets: JivoWidget[]) => void;
};

export function useJivoOauthConnectIntegration({ onAuthorized }: UseJivoOauthConnectIntegrationParams) {
    const { isConnecting, handleConnect } = useOauthPopupConnect({
        cookieKey: JIVO_OAUTH_STORAGE_KEY,
        serviceName: JIVO_SERVICE_NAME,
        getCredentials: integrationJivoCredentialsGet,
        buildUrl: getJivoOauthUrl,
        onCookieSuccess: async ({ code, state }) => {
            const { widgets } = await integrationJivoWidgetsGet({
                authorization_code: code,
                state_token: state,
            });

            onAuthorized(widgets);
        },
    });

    return { isConnecting, handleConnect };
}
